import React from 'react'
import {useSelector} from 'react-redux'
import {selectKP11SelectCartCentersNApps} from '../../../../../../app-store/kp11CartSlice'
import {
  CardPlanBodyStyle,
  // CardPlanAddToCartStyle,
} from '../kp-11Link-catalog-cards-style'
// import {kpSuccessIcon} from '../../../../../../assets'
// import {PlanRadioInput} from '../../../kp-11Link-reusable-components/kp-plan-radio-input'
import {CardPlanItemWrapStyle} from '../../../kp-11Link-reusable-components/kp-plan-radio-input-style'
import {
  buildCartEntity,
  getItemFromCart,
  isItemAtMaxQty,
} from '../../../kp-11Link-utility/kp11-utility'
// import {DELAY_HIDE_IN_SEC} from '../../../../../../utils/constants'
import {Button} from '@thryvlabs/maverick'
import {ProductNamePriceComponent} from '../../../../kp-card-type/product-name-price-component'

export const KP11LinkWCCardComponent = ({
  groupKey,
  items = [],
  onSelectItem,
  disabled,
  addedToCart,
  selectedCountry = 'US',
}) => {
  // Get selectedItem from structured cart
  const cartCentersAndApps = useSelector(selectKP11SelectCartCentersNApps)
  getItemFromCart({
    cartCentersAndApps,
    groupKey,
    items,
  })
  const isMaxQtyReached = isItemAtMaxQty({
    cartCentersAndApps,
    item: items?.[0],
  })
  // const [add2CartBannerStatus, setAdd2BannerStatus] = useState(addedToCart)
  // useEffect(() => {
  //   if (addedToCart) {
  //     setAdd2BannerStatus(true)
  //     setTimeout(() => {
  //       setAdd2BannerStatus(false)
  //     }, DELAY_HIDE_IN_SEC * 1000)
  //   }
  // }, [addedToCart])

  // const isPlanDisabled = (disabled, item) => {
  //   const isItemAllreadyAdded = item?.isAlreadyAdded
  //   const isdisabled = disabled || isItemAllreadyAdded
  //   return isdisabled
  // }
  // // --- Determine checked and disabled state ---
  // const getItemState = item => {
  //   const selectedCode = selectedItem?.code

  //   // Default case
  //   return {checked: selectedCode === item.code, disabled: false}
  // }

  return (
    <CardPlanBodyStyle>
      <div className="card-plan-subText">
        Review/Approval can take up to 3 business days, after filling out the
        Company Onboarding wizard
      </div>

      <CardPlanItemWrapStyle>
        {/* {items.map(item => {
          const {checked} = getItemState(item)
          return (
            <PlanRadioInput
              key={item.code}
              item={item}
              checked={checked}
              disabled={isPlanDisabled(disabled, item)}
              onChange={() => {
                const updatedItem = buildCartEntity({
                  kind: 'item',
                  source: {...item, groupKey, section: 'centers'},
                  selectedCountry,
                  quantity: 1,
                })
                onSelectItem(updatedItem)
              }}
            />
          )
        })} */}
        <ProductNamePriceComponent
          cardDetail={items[0]}
          isIconRequired={false}
          isNameRequired={false}
          customFields={{}}
          country={selectedCountry}
        />
      </CardPlanItemWrapStyle>
      <div className="d-flex w-100 justify-content-center">
        <Button
          variant="primary"
          disabled={disabled || isMaxQtyReached}
          onClick={() => {
            const updatedItem = buildCartEntity({
              kind: 'item',
              source: {...items[0], groupKey, section: 'centers'},
              selectedCountry,
              quantity: 1,
            })
            onSelectItem(updatedItem)
          }}
        >
          Add to Cart
        </Button>
      </div>
      {/* {add2CartBannerStatus && (
        <CardPlanAddToCartStyle>
          <img src={kpSuccessIcon} alt="success icon" />
          <span>Added to cart</span>
        </CardPlanAddToCartStyle>
      )} */}
    </CardPlanBodyStyle>
  )
}
